import React from "react";
import { Col, Row, Upload } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import { MailOutlined, PhoneOutlined, UploadOutlined } from "@ant-design/icons";
import styles from "./AdministratorInformation.module.css";

const AdministratorInformation = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="full_name"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="full_name"
              label="Full Name"
              showRequired
              labelColor="#171717"
              placeholder="Enter First Name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="designation"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="designation"
              label="Designation/Role"
              showRequired
              labelColor="#171717"
              placeholder="Enter name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="national_id"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="national_id"
              label="National ID/Passport"
              showOptional
              labelColor="#171717"
              placeholder="Enter number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="email"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="email"
              label="Email"
              showOptional
              type="email"
              labelColor="#171717"
              placeholder="Enter Email"
              size="large"
              value={value}
              prefix={
                <MailOutlined style={{ color: "#999999", paddingRight: 4 }} />
              }
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="phone_number"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="phone_number"
              label="Phone Number"
              showRequired
              labelColor="#171717"
              placeholder="Enter Phone Number"
              type="number"
              size="large"
              value={value}
              prefix={
                <PhoneOutlined style={{ color: "#999999", paddingRight: 4 }} />
              }
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <label
          htmlFor="file"
          style={{
            display: "block",
            marginBottom: 8,
            color: "#171717",
            fontWeight: 400,
          }}
        >
          <span>Photo</span>
          <span  style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
        </label>
        <Controller
          name="administrator_picture"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Upload
              beforeUpload={(file) => {
                onChange(file);
                return false;
              }}
              showUploadList={false}
              accept=".jpg,.png"
              status={error ? "error" : ""}
              className={styles.common_input_styles}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  border: `1px solid ${error ? "red" : "#D0D5DD"} `,
                  paddingInline: 16,
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <UploadOutlined style={{ color: "#8C8C8C", width: "auto", marginRight: 12 }} />
                <div style={{ color: "#8C8C8C", fontFamily: "Inter" }}>
                  {value?.name ?? "Select a file to Upload"}
                </div>
              </div>
            </Upload>
          )}
        />
      </Col>
    </Row>
  );
};

export default AdministratorInformation;
